export default __webpack_public_path__ + "static/media/logo-esencial.d699b42a.png";